import React, { useMemo } from "react";
import { SideDrawer, XIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import useWindowSize from "@/hooks/use-window-size/use-window-size";

import Style from "./price-drawer.module.css";

type PriceDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  drawerTitle: string;
  drawerContent: string;
  closeButtonDrawer: string;
};

function PriceDrawer({
  isOpen,
  onClose,
  drawerTitle,
  drawerContent,
  closeButtonDrawer,
}: Readonly<PriceDrawerProps>) {
  const windowSize = useWindowSize();

  const drawerWidth = useMemo(() => {
    if (windowSize && windowSize < 600) {
      return 336;
    }
    if (windowSize && windowSize < 904) {
      return 376;
    }
    return 504;
  }, [windowSize]);
  return (
    <SideDrawer
      wrapperStyles="rounded-l-2xl h-screen "
      drawerContentWrapperClassName="p-spacing-xl md:p-spacing-xxl bg-surface-neutral-option-1"
      drawerContentClassName="w-full"
      isOpen={isOpen}
      onCloseDrawer={onClose}
      width={drawerWidth}
      closeBtnWrapperStyles="grid justify-items-end mb-spacing-l hidden"
      closeButton={<div />}
    >
      {/* Close Button */}
      <div className="flex justify-end mb-spacing-m md:mb-spacing-l">
        <LabelButtonWrapper
          type="button"
          hierarchy="tertiary"
          label={closeButtonDrawer}
          onClick={onClose}
          isRightIcon
          rightIcon={<XIcon stroke="interactive-secondary-default" />}
          className={`text-[18px] font-body-font !px-spacing-xxs leading-[18px] h-[24px] text-border-accent-1-primary font-[600] ${Style.closeButton}`}
        />
      </div>

      {/* Drawer Content */}
      <div className="flex flex-col gap-spacing-xs md:gap-spacing-m">
        <h2 className="text-s md:text-l text-text-accent-1-primary font-header-font leading-custom-size-sm md:leading-[27.5px]">
          {drawerTitle}
        </h2>
        <div className="text-2xs md:text-xs text-text-functional font-body-font leading-6 md:leading-custom-size-xxl">
          <RichText
            richText={drawerContent}
            className={`text-2xs md:text-xs text-text-functional font-body-font leading-6 md:leading-custom-size-xxl font-normal ${Style.spacer}`}
          />
        </div>
      </div>
    </SideDrawer>
  );
}

export default PriceDrawer;
